module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-wrapper",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 480
    },
    on: {
      "on-change": _vm.change
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('CarouselItem', {
      key: item.aid
    }, [_c('router-link', {
      staticClass: "img-box",
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": item.atturl
      }
    })])], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-698066c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/gold-shop/banner.vue
// module id = 1627
// module chunks = 1